export const formatBetterDocBody = (body: string) => {
  try {
    const parsedBody: unknown = JSON.parse(body)

    return JSON.stringify(parsedBody, null, 2)
  } catch {
    return body
  }
}
